<template>
  <section :class="{ 'solicitacao-visita--modal': emModal }">
    <div v-if="!emModal" class="titulo">
      <div class="margem container">
        <div class="linha alinha-v">
          <div class="m-icone esquerda"><a @click="$router.back()" style="cursor: pointer" class="icone-voltar m-d"></a>
          </div>
          <h2>{{ tituloPagina }}</h2>
        </div>
      </div>
    </div>
    <div v-if="!id && !emModal" class="margem container">
      <p class="fonte-menor fonte-fraca cadastro-anfitriao-dica"> Informe o visitante para a recepção; ela completará
        documentos e check-in depois. </p>
    </div>
    <form v-if="id" class="solicitacao-visita-form" @submit.prevent="enviar">
      <!-- Aviso quando a visita foi cancelada -->
      <div v-if="id && form.cancelada" class="margem container">
        <div class="bloco margem margem-topo sol-alerta sol-alerta--erro" role="alert">
          <i class="fa-solid fa-circle-xmark sol-alerta-icone" aria-hidden="true"></i>
          <div class="sol-alerta-texto">
            <strong>Esta visita foi cancelada.</strong> Você pode visualizar os dados, mas alterações podem não ser permitidas.
          </div>
        </div>
      </div>
      <!-- Aviso: anfitrião(ã) em Minhas solicitações — só acompanha o fluxo -->
      <div v-if="id && informadaPeloAnfitriao && fluxoConviteDigitalSomenteLeituraAnfitriao && exigeFluxoDigitalRecepcao" class="margem container">
        <div class="bloco margem margem-topo sol-alerta sol-alerta--info">
          <i class="fa-solid fa-circle-info sol-alerta-icone" aria-hidden="true"></i>
          <div class="sol-alerta-texto">
            <strong>Esta solicitação foi informada por você.</strong> A recepção conduz o <strong>fluxo digital</strong>
            em quatro etapas (e-mail ao visitante, confirmação de presença, agendamento de sala e encaminhamento
            logístico). Abaixo você acompanha o andamento; as etapas são registradas pela recepção.
          </div>
        </div>
      </div>
      <div v-else-if="id && informadaPeloAnfitriao && fluxoConviteDigitalSomenteLeituraAnfitriao && !exigeFluxoDigitalRecepcao" class="margem container">
        <div class="bloco margem margem-topo sol-alerta sol-alerta--info">
          <i class="fa-solid fa-circle-info sol-alerta-icone" aria-hidden="true"></i>
          <div class="sol-alerta-texto">
            <strong>Visita de fornecedor, prestador de serviço ou outros.</strong> O fluxo digital da recepção não se aplica — basta agendar a
            visita e realizar o check-in no dia.
          </div>
        </div>
      </div>
      <!-- Aviso quando recepcionista está completando solicitação informada pelo anfitrião(ã) -->
      <div v-if="id && informadaPeloAnfitriao && !fluxoConviteDigitalSomenteLeituraAnfitriao && exigeFluxoDigitalRecepcao" class="margem container">
        <div class="bloco margem margem-topo sol-alerta sol-alerta--info">
          <i class="fa-solid fa-circle-info sol-alerta-icone" aria-hidden="true"></i>
          <div class="sol-alerta-texto">
            <strong>Esta solicitação foi informada pelo anfitrião(ã).</strong> Os dados básicos do visitante já foram
            informados. Siga o <strong>fluxo digital</strong> abaixo nas quatro etapas (e-mail ao visitante,
            confirmação de presença, sala e logística). Complete os campos desta tela conforme necessário e registre cada
            etapa concluída.
          </div>
        </div>
      </div>
      <div v-else-if="id && informadaPeloAnfitriao && !fluxoConviteDigitalSomenteLeituraAnfitriao && !exigeFluxoDigitalRecepcao" class="margem container">
        <div class="bloco margem margem-topo sol-alerta sol-alerta--info">
          <i class="fa-solid fa-circle-info sol-alerta-icone" aria-hidden="true"></i>
          <div class="sol-alerta-texto">
            <strong>Visita de fornecedor, prestador de serviço ou outros.</strong> O fluxo digital da recepção (e-mail, confirmação de presença,
            sala e logística) <strong>não é necessário</strong>. Complete os dados da visita abaixo e prossiga com o
            agendamento e check-in.
          </div>
        </div>
      </div>
      <div v-if="id && !form.cancelada && visitaDataPassadaSomenteLeitura" class="margem container">
        <div class="bloco margem margem-topo sol-alerta sol-alerta--passada aviso-visita-passada" role="status">
          <i class="fa-solid fa-lock sol-alerta-icone" aria-hidden="true"></i>
          <div class="sol-alerta-texto">
            <strong>{{ form.ehVisitaPorPeriodo ? 'Período da visita já passou.' : 'Data da visita já passou.' }}</strong> Os dados podem ser consultados, mas não é possível alterá-los pela web.
          </div>
        </div>
      </div>
      <!-- Status do agendamento no topo (recepção e anfitrião) -->
      <div v-if="mostrarStatus" class="margem container solicitacao-form-secao-status">
        <div class="bloco margem margem-topo solicitacao-form-secao-cartao">
          <h2 class="solicitacao-form-secao-cartao-titulo">
            <i class="fa-solid fa-list-check"></i> Status do Agendamento
          </h2>
          <div class="linha tags solicitacao-form-status-chips">
            <template v-for="(etapa, idx) in etapasStatus" :key="'st-top-' + etapa.valor">
              <span
                class="chip chip-status-etapa"
                :class="statusPainel(form.statusAgendamento) >= etapa.valor ? classeBadgeStatus(etapa.valor) : 'status-agendada'"
              >
                <i v-if="statusPainel(form.statusAgendamento) > etapa.valor" class="fa-solid fa-check"></i>
                <span v-else>{{ idx + 1 }}</span>
                <span class="chip-label">{{ etapa.label }}</span>
              </span>
            </template>
          </div>
        </div>
      </div>
      <div v-if="id && informadaPeloAnfitriao && exigeFluxoDigitalRecepcao" class="margem container">
        <div class="bloco margem margem-topo fluxo-digital-card">
          <header class="fluxo-digital-cabecalho">
            <span class="fluxo-digital-cabecalho-icone" aria-hidden="true">
              <i class="fa-solid fa-envelope-open-text"></i>
            </span>
            <div class="fluxo-digital-cabecalho-textos">
              <h2 class="fluxo-digital-titulo">Fluxo digital da visita</h2>
              <p v-if="fluxoConviteDigitalSomenteLeituraAnfitriao" class="fluxo-digital-subtitulo">
                O andamento abaixo reflete o que a recepção já registrou em cada etapa.
              </p>
              <p v-else class="fluxo-digital-subtitulo">
                Registre as quatro etapas na ordem, até o encaminhamento das necessidades logísticas.
              </p>
            </div>
          </header>
          <ol class="fluxo-digital-etapas fluxo-convite-etapas">
            <li
              v-for="etapa in etapasFluxoConviteDigital"
              :key="etapa.patch"
              class="fluxo-digital-etapa"
              :class="{ 'fluxo-digital-etapa--feita': !!dataEtapaFluxoDigital(etapa) }"
            >
              <div class="fluxo-digital-etapa-linha">
                <span
                  class="fluxo-digital-etapa-num"
                  :class="dataEtapaFluxoDigital(etapa) ? 'fluxo-digital-etapa-num--ok' : 'fluxo-digital-etapa-num--pendente'"
                >{{ etapa.num }}</span>
                <div class="fluxo-digital-etapa-corpo">
                  <h3 class="fluxo-digital-etapa-titulo">{{ etapa.titulo }}</h3>
                  <p class="fluxo-digital-etapa-desc">{{ etapa.descricao }}</p>
                  <div class="fluxo-digital-etapa-rodape">
                    <template v-if="dataEtapaFluxoDigital(etapa) && fluxoConviteDigitalSomenteLeituraAnfitriao">
                      <div class="linha-fluxo-convite-status fluxo-digital-status-linha">
                        <span class="chip bg-sucesso">Confirmado</span>
                        <span class="fonte-menor fonte-fraca">{{ formatarDataHora(dataEtapaFluxoDigital(etapa)) }}</span>
                      </div>
                    </template>
                    <template v-else-if="dataEtapaFluxoDigital(etapa)">
                      <span class="fluxo-digital-feito-msg">
                        <i class="fa-solid fa-circle-check" aria-hidden="true"></i>
                        Feito em {{ formatarDataHora(dataEtapaFluxoDigital(etapa)) }}
                      </span>
                    </template>
                    <span v-else-if="fluxoConviteDigitalSomenteLeituraAnfitriao" class="chip chip-fluxo-pendente">Pendente</span>
                    <button
                      v-else
                      type="button"
                      class="fluxo-digital-btn-acao"
                      @click="marcarEtapaFluxoDigital(etapa)"
                      :disabled="salvandoConvite || formEdicaoDesabilitada"
                    >
                      <i v-if="salvandoConvite === etapa.salvando" class="fas fa-spinner fa-spin" aria-hidden="true"></i>
                      <i v-else class="fa-solid fa-check" aria-hidden="true"></i>
                      <span>{{ textoBotaoFluxoDigitalEtapas }}</span>
                    </button>
                  </div>
                </div>
              </div>
            </li>
          </ol>
          <div v-if="form.conviteCompleto" class="fluxo-digital-conclusao">
            <i class="fa-solid fa-circle-check fluxo-digital-conclusao-icone" aria-hidden="true"></i>
            <p v-if="fluxoConviteDigitalSomenteLeituraAnfitriao" class="fluxo-digital-conclusao-texto">
              Fluxo digital concluído — a visita pode ser agendada pela recepção (data, horário e status).
            </p>
            <p v-else class="fluxo-digital-conclusao-texto">
              Fluxo digital concluído — visita pode ser agendada. Preencha data e horário abaixo e salve, ou avance o status
              para «Acompanhamento».
            </p>
          </div>
        </div>
      </div>
      <fieldset class="solicitacao-edicao-fieldset" :disabled="formEdicaoDesabilitada">
      <!-- Informações da Visita -->
      <div class="margem container">
        <div class="bloco margem margem-topo solicitacao-form-secao-cartao">
          <h2 class="solicitacao-form-secao-cartao-titulo">
            <i class="fa-solid fa-calendar-day"></i> Informações da Visita
          </h2>
          <div class="grid-4">
            <div>
              <label for="motivoVisitaSol">Motivo da visita <span style="color: var(--cor-erro);">*</span></label>
              <select id="motivoVisitaSol" v-model="motivoId" required>
                <option value="">Selecione o motivo</option>
                <option v-for="m in motivosVisita" :key="'motivo-ed-' + m.id" :value="m.id">{{ m.label }}</option>
              </select>
            </div>
            <div>
              <span class="label-picker" id="label-area-setor">Área ou setor a ser visitado <span
                  class="req">*</span></span>
              <button type="button" class="btn-picker-setor" :disabled="setoresCarregando"
                aria-labelledby="label-area-setor" @click="modalSetorAberto = true">
                <span class="btn-picker-texto" :class="{ placeholder: !form.areaSetorVisitado?.trim() }">{{
                  labelSetorVisita }}</span>
                <i class="fa-solid fa-chevron-down"></i>
              </button>
            </div>
            <div class="col-4 solicitacao-linha-tipo-agendamento">
              <span class="label-picker">Tipo de agendamento</span>
              <div class="tipo-agendamento-opcoes">
                <label><input v-model="tipoAgendamentoVisita" type="radio" value="diaria" /> Visita diária</label>
                <label><input v-model="tipoAgendamentoVisita" type="radio" value="periodo" /> Visita por período</label>
              </div>
              <p v-if="tipoAgendamentoVisita === 'periodo'" class="fonte-menor fonte-fraca hint-multi-visitantes">
                O visitante poderá comparecer em todos os dias entre a data inicial e a data final (check-in por dia).
              </p>
            </div>
            <div class="col-4 solicitacao-grid-datas-horarios">
              <div class="grid-datas-horarios-inner">
                <div>
                  <label for="dataVisitaSol">{{ tipoAgendamentoVisita === 'periodo' ? 'Data inicial' : 'Data da visita' }}
                    <span v-if="form.agendada" style="color: var(--cor-erro);">*</span></label>
                  <input id="dataVisitaSol" v-model="form.dataVisita" type="date" :required="form.agendada" />
                </div>
                <div v-if="tipoAgendamentoVisita === 'periodo'">
                  <label for="dataVisitaFimSol">Data final <span style="color: var(--cor-erro);">*</span></label>
                  <input
                    id="dataVisitaFimSol"
                    v-model="form.dataVisitaFim"
                    type="date"
                    :min="form.dataVisita || undefined"
                    :required="tipoAgendamentoVisita === 'periodo'"
                  />
                </div>
                <div>
                  <label for="horarioEntradaSol">Horário previsto de entrada</label>
                  <input id="horarioEntradaSol" v-model="form.horarioEntradaPrevisto" type="time" />
                </div>
                <div>
                  <label for="horarioSaidaSol">Horário previsto de saída</label>
                  <input id="horarioSaidaSol" v-model="form.horarioSaidaPrevisto" type="time" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Dados do(s) visitante(s) -->
      <div class="margem container">
        <div class="bloco margem margem-topo solicitacao-form-secao-cartao">
          <h2 class="solicitacao-form-secao-cartao-titulo">
            <i class="fa-solid fa-id-card"></i> Dados dos visitantes
          </h2>
          <p v-if="visitantesForm.length > 1" class="fonte-menor fonte-fraca hint-multi-visitantes">
            Mesma visita e mesmas necessidades logísticas abaixo; cada pessoa terá cadastro e check-in individualizados.
          </p>
          <template v-if="visitantesForm.length">
            <div>
              <label for="empresaOrigemSol">Empresa de origem (opcional)</label>
              <input id="empresaOrigemSol" v-model="form.empresaOrigem" type="text" placeholder="Empresa" />
            </div>
            <div
              v-for="(visitante, idx) in visitantesForm"
              :key="visitante._slotId || 'sol-v-' + idx"
              class="visitante-slot-card bloco margem"
            >
              <div class="visitante-slot-cabecalho">
                <h3 class="visitante-slot-titulo">Visitante {{ idx + 1 }}</h3>
                <button
                  v-if="visitantesForm.length > 1 && !formEdicaoDesabilitada"
                  type="button"
                  class="acao-secundaria btn-remover-slot"
                  @click="removerVisitanteDoFormulario(idx)"
                >
                  Remover
                </button>
              </div>
              <div class="campo-linha-cheia">
                <button type="button" class="btn-buscar-cadastro" @click="abrirModalVisitanteBusca(idx)">
                  <i class="fa-solid fa-magnifying-glass"></i> Buscar visitante cadastrado
                </button>
                <template v-if="visitante.visitanteId != null && Number(visitante.visitanteId) > 0">
                  <p class="fonte-menor fonte-fraca hint-anfitriao">
                    <i class="fa-solid fa-link"></i> Vinculado ao cadastro de visitantes. Você pode ajustar os campos abaixo
                    antes de salvar.
                  </p>
                  <button type="button" class="btn-alterar-anfitriao" @click="limparVinculoVisitanteCadastrado(idx)">
                    Preencher manualmente / outro cadastro
                  </button>
                </template>
                <p v-else class="fonte-menor fonte-fraca hint-anfitriao">
                  Opcional: busque por nome ou documento para carregar um visitante já cadastrado.
                </p>
              </div>
              <div class="grid-4">
                <div>
                  <label :for="'nomeCompletoSol-' + idx">Nome completo <span style="color: var(--cor-erro);">*</span></label>
                  <input
                    :id="'nomeCompletoSol-' + idx"
                    v-model="visitantesForm[idx].nomeCompleto"
                    type="text"
                    placeholder="Nome completo"
                  />
                </div>
                <div>
                  <label :for="'docSol-' + idx">
                    CPF ou RG
                    <span style="color: var(--cor-fonte-fraca); font-weight: 400"> (opcional aqui; obrigatório no check-in)</span>
                  </label>
                  <input
                    :id="'docSol-' + idx"
                    :value="valorDocumentoUnicoVisitante(visitantesForm[idx])"
                    type="text"
                    placeholder="CPF ou RG"
                    @input="atualizarDocumentoVisitante(idx, $event.target.value)"
                  />
                </div>
                <div>
                  <label :for="'emailSol-' + idx">E-mail (opcional)</label>
                  <input :id="'emailSol-' + idx" v-model="visitantesForm[idx].email" type="text" placeholder="E-mail" />
                </div>
                <div>
                  <label :for="'telefoneSol-' + idx">Telefone / WhatsApp (opcional)</label>
                  <input
                    :id="'telefoneSol-' + idx"
                    v-model="visitantesForm[idx].telefoneWhatsapp"
                    type="text"
                    placeholder="Telefone ou WhatsApp"
                  />
                </div>
              </div>
            </div>
            <div v-if="!formEdicaoDesabilitada" class="alinha-centro" style="margin-top: 0.5rem">
              <button type="button" class="acao-secundaria" @click="adicionarVisitanteAoFormulario">
                <i class="fa-solid fa-user-plus"></i> Adicionar outro visitante
              </button>
            </div>
            <div style="margin-top: 1rem;">
              <label for="anexoSol">Anexo do documento (opcional):</label>
              <input id="anexoSol" type="file" accept=".pdf,.jpg,.jpeg,.png" @change="onAnexoChange" />
              <span v-if="form.anexoDocumento" class="fonte-menor" style="margin-left: 0.5rem;">{{ nomeAnexo }}</span>
            </div>
          </template>
        </div>
      </div>
      <!-- Tipo de Visitante -->
      <div class="margem container">
        <div class="bloco margem margem-topo solicitacao-form-secao-cartao">
          <h2 class="solicitacao-form-secao-cartao-titulo">
            <i class="fa-solid fa-handshake"></i> Tipo de Visitante
          </h2>
          <div class="grid-4">
            <div class="bloco margem col-3">
              <div>
                <label><input v-model="form.tipoCliente" type="checkbox" /> Cliente</label>
              </div>
              <div>
                <label><input v-model="form.tipoFornecedor" type="checkbox" /> Fornecedor</label>
              </div>
              <div>
                <label><input v-model="form.tipoPrestadorServico" type="checkbox" /> Prestador de serviço</label>
              </div>
              <div>
                <label><input v-model="form.tipoParceiros" type="checkbox" /> Parceiros</label>
              </div>
              <div>
                <label><input v-model="form.tipoOutros" type="checkbox" /> Outros</label>
                <input v-if="form.tipoOutros" id="tipoOutrosDescricaoSol" v-model="form.tipoOutrosDescricao" type="text"
                  placeholder="Descreva o tipo de visitante" style="margin-top: 0.5rem; width: 100%; max-width: 28rem;" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Necessidades logísticas -->
      <div class="margem container">
        <div class="bloco margem margem-topo solicitacao-form-secao-cartao">
          <h2 class="solicitacao-form-secao-cartao-titulo">
            <i class="fa-solid fa-industry"></i> Necessidades logísticas
          </h2>
          <div class="grid-4">
            <div class="bloco margem col-3">
              <p class="fonte-menor fonte-fraca m-b">Marque o que for necessário para o dia da visita.</p>
              <div>
                <label for="nl-fab-sol"><input id="nl-fab-sol" v-model="form.visitaraFabrica" type="checkbox" /> Visitará à
                  fábrica</label>
              </div>
              <div>
                <label for="nl-lite-sol"><input id="nl-lite-sol" v-model="form.salaReuniaoLite" type="checkbox" /> Sala de
                  reunião Lite</label>
              </div>
              <div>
                <label for="nl-hard-sol"><input id="nl-hard-sol" v-model="form.salaReuniaoHard" type="checkbox" /> Sala de
                  reunião Hard</label>
              </div>
              <div>
                <label for="nl-cafe-sol"><input id="nl-cafe-sol" v-model="form.cafe" type="checkbox" /> Café</label>
              </div>
              <div>
                <label for="nl-agua-sol"><input id="nl-agua-sol" v-model="form.agua" type="checkbox" /> Água</label>
              </div>
              <div>
                <label for="nl-pao-sol"><input id="nl-pao-sol" v-model="form.paoQueijoBiscoito" type="checkbox" /> Pão de
                  queijo ou biscoito</label>
              </div>
              <div>
                <label for="nl-brinde-sol"><input id="nl-brinde-sol" v-model="form.brinde" type="checkbox" /> Brinde</label>
              </div>
            </div>
          </div>
        </div>
      </div>
      </fieldset>
      <!-- Ações -->
      <div class="grid margem container solicitacao-form-acoes">
        <div class="col-2 alinha-centro solicitacao-form-acoes-inner">
          <button type="submit" :disabled="salvando || formEdicaoDesabilitada">
            <i v-if="salvando" class="fas fa-spinner fa-spin"></i>
            <span v-if="salvando">Salvando...</span>
            <span v-else>{{ textoBotaoEnviar }}</span>
          </button>
          <router-link v-if="!emModal" to="/solicitacoes" class="acao-secundaria" style="cursor: pointer; margin-left: 0.5rem;">Voltar à
            lista</router-link>
          <button
            v-else
            type="button"
            class="acao-secundaria solicitacao-modal-btn-fechar"
            @click="fecharEmbedded"
          >
            Fechar
          </button>
        </div>
      </div>
    </form>
    <!-- Nova visita — anfitrião(ã) (informar para a recepção) ou recepção (modal da agenda) -->
    <form
      v-if="!id"
      class="solicitacao-visita-form"
      :class="{ 'solicitacao-visita-form--recepcao-modal': emModal && modoRecepcaoAgenda }"
      @submit.prevent="emModal && modoRecepcaoAgenda ? enviarRecepcaoAgenda() : enviarAnfitriao()"
    >
      <div class="margem container">
        <div class="bloco margem margem-topo solicitacao-form-secao-cartao">
          <h2 class="solicitacao-form-secao-cartao-titulo">
            <i class="fa-solid fa-calendar-day"></i> Informações da Visita
          </h2>
          <div class="grid-4">
            <div>
              <label for="motivoVisita-anf">Motivo da visita</label>
              <select id="motivoVisita-anf" v-model="motivoId">
                <option value="">Selecione o motivo</option>
                <option v-for="m in motivosVisita" :key="'motivo-anf-' + m.id" :value="m.id">{{ m.label }}</option>
              </select>
            </div>
            <div>
              <span class="label-picker" id="label-area-setor-anf">Área ou setor a ser visitado</span>
              <button type="button" class="btn-picker-setor" :disabled="setoresCarregando"
                aria-labelledby="label-area-setor-anf" @click="modalSetorAberto = true">
                <span class="btn-picker-texto" :class="{ placeholder: !form.areaSetorVisitado?.trim() }">{{
                  labelSetorVisita }}</span>
                <i class="fa-solid fa-chevron-down"></i>
              </button>
            </div>
            <div class="col-4 solicitacao-linha-tipo-agendamento">
              <span class="label-picker">Tipo de agendamento</span>
              <div class="tipo-agendamento-opcoes">
                <label><input v-model="tipoAgendamentoVisita" type="radio" value="diaria" /> Visita diária</label>
                <label><input v-model="tipoAgendamentoVisita" type="radio" value="periodo" /> Visita por período</label>
              </div>
              <p v-if="tipoAgendamentoVisita === 'periodo'" class="fonte-menor fonte-fraca hint-multi-visitantes">
                O visitante poderá comparecer em todos os dias entre a data inicial e a data final (check-in por dia).
              </p>
            </div>
            <div class="col-4 solicitacao-grid-datas-horarios">
              <div class="grid-datas-horarios-inner">
                <div>
                  <label for="dataVisita-anf">{{ tipoAgendamentoVisita === 'periodo' ? 'Data inicial' : 'Data da visita' }}</label>
                  <input id="dataVisita-anf" v-model="form.dataVisita" type="date" />
                </div>
                <div v-if="tipoAgendamentoVisita === 'periodo'">
                  <label for="dataVisitaFim-anf">Data final</label>
                  <input
                    id="dataVisitaFim-anf"
                    v-model="form.dataVisitaFim"
                    type="date"
                    :min="form.dataVisita || undefined"
                  />
                </div>
                <div>
                  <label for="horarioEntrada-anf">Horário previsto de entrada</label>
                  <input id="horarioEntrada-anf" v-model="form.horarioEntradaPrevisto" type="time" />
                </div>
                <div>
                  <label for="horarioSaida-anf">Horário previsto de saída</label>
                  <input id="horarioSaida-anf" v-model="form.horarioSaidaPrevisto" type="time" />
                </div>
              </div>
            </div>
            <div v-if="emModal && modoRecepcaoAgenda" class="col-4 solicitacao-linha-observacao">
              <label for="observacao-visita-recepcao-modal">Observação <span class="fonte-menor fonte-fraca">(opcional)</span></label>
              <textarea
                id="observacao-visita-recepcao-modal"
                v-model="form.observacaoVisita"
                rows="2"
                placeholder="Detalhes adicionais da visita"
                class="solicitacao-textarea-obs"
              />
            </div>
          </div>
        </div>
      </div>
      <div v-if="!(emModal && modoRecepcaoAgenda)" class="margem container">
        <div class="bloco margem margem-topo solicitacao-form-secao-cartao">
          <h2 class="solicitacao-form-secao-cartao-titulo">
            <i class="fa-solid fa-user-tie"></i> Dados do Anfitrião(ã)
          </h2>
          <div class="grid-4">
            <div class="bloco margem col-3">
              <div class="campo-linha-cheia">
                <button type="button" class="btn-buscar-cadastro" @click="abrirModalAnfitriao">
                  <i class="fa-solid fa-magnifying-glass"></i> Buscar anfitrião(ã) </button>
                <template v-if="anfitriaoUsuarioId != null">
                  <div class="anfit-leitura-bloco">
                    <div class="anfit-leitura-linha">
                      <div class="anfit-leitura-campo">
                        <span class="label-readonly">Nome do anfitrião(ã) <span class="req">*</span></span>
                        <div class="read-only-box">{{ form.nomeAnfitriao }}</div>
                      </div>
                      <button type="button" class="btn-alterar-anfitriao"
                        @click="limparAnfitriaoSelecionado">Alterar</button>
                    </div>
                    <div class="anfit-leitura-campo margem-topo-peq">
                      <span class="label-readonly">Setor</span>
                      <div class="read-only-box">{{ (form.areaDepartamento || "").trim() ? form.areaDepartamento : "—" }}
                      </div>
                      <p class="fonte-menor fonte-fraca hint-anfitriao">Somente leitura — preenchido automaticamente com o
                        cadastro (RH).</p>
                    </div>
                  </div>
                </template>
                <p v-else class="fonte-menor fonte-fraca hint-anfitriao"> Use a busca para escolher o anfitrião(ã). O nome e
                  o setor serão exibidos aqui e não podem ser editados manualmente. </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="margem container">
        <div class="bloco margem margem-topo solicitacao-form-secao-cartao">
          <h2 class="solicitacao-form-secao-cartao-titulo">
            <i class="fa-solid fa-id-card"></i> Dados dos visitantes
          </h2>
          <p v-if="visitantesForm.length > 1" class="fonte-menor fonte-fraca hint-multi-visitantes">
            Mesma visita e mesmas necessidades logísticas abaixo; cada pessoa será tratada no check-in individualmente.
          </p>
          <template v-if="visitantesForm.length">
            <div>
              <label for="empresaOrigem-anf">Empresa de origem (opcional)</label>
              <input id="empresaOrigem-anf" v-model="form.empresaOrigem" type="text" placeholder="Empresa" />
            </div>
            <div
              v-for="(visitante, idx) in visitantesForm"
              :key="visitante._slotId || 'anf-v-' + idx"
              class="visitante-slot-card bloco margem"
            >
              <div class="visitante-slot-cabecalho">
                <h3 class="visitante-slot-titulo">Visitante {{ idx + 1 }}</h3>
                <button
                  v-if="visitantesForm.length > 1"
                  type="button"
                  class="acao-secundaria btn-remover-slot"
                  @click="removerVisitanteDoFormulario(idx)"
                >
                  Remover
                </button>
              </div>
              <div class="campo-linha-cheia">
                <button type="button" class="btn-buscar-cadastro" @click="abrirModalVisitanteBusca(idx)">
                  <i class="fa-solid fa-magnifying-glass"></i> Buscar visitante cadastrado
                </button>
                <template v-if="visitante.visitanteId != null && Number(visitante.visitanteId) > 0">
                  <p class="fonte-menor fonte-fraca hint-anfitriao">
                    <i class="fa-solid fa-link"></i> Vinculado ao cadastro de visitantes. Você pode ajustar os campos abaixo
                    antes de enviar.
                  </p>
                  <button type="button" class="btn-alterar-anfitriao" @click="limparVinculoVisitanteCadastrado(idx)">
                    Preencher manualmente / outro cadastro
                  </button>
                </template>
                <p v-else class="fonte-menor fonte-fraca hint-anfitriao">
                  Opcional: busque por nome ou documento para carregar um visitante já cadastrado.
                </p>
              </div>
              <div class="grid-4">
                <div>
                  <label :for="'nomeCompleto-anf-' + idx">Nome completo <span style="color: var(--cor-erro);">*</span></label>
                  <input
                    :id="'nomeCompleto-anf-' + idx"
                    v-model="visitantesForm[idx].nomeCompleto"
                    type="text"
                    placeholder="Nome completo"
                  />
                </div>
                <div>
                  <label :for="'doc-anf-' + idx">
                    CPF ou RG
                    <span style="color: var(--cor-fonte-fraca); font-weight: 400"> (opcional aqui; obrigatório no check-in)</span>
                  </label>
                  <input
                    :id="'doc-anf-' + idx"
                    :value="valorDocumentoUnicoVisitante(visitantesForm[idx])"
                    type="text"
                    placeholder="CPF ou RG"
                    @input="atualizarDocumentoVisitante(idx, $event.target.value)"
                  />
                </div>
                <div>
                  <label :for="'email-anf-' + idx">E-mail (opcional)</label>
                  <input :id="'email-anf-' + idx" v-model="visitantesForm[idx].email" type="text" placeholder="E-mail" />
                </div>
                <div>
                  <label :for="'telefone-anf-' + idx">
                    Telefone / WhatsApp
                    <span style="color: var(--cor-fonte-fraca); font-weight: 400"> (opcional)</span>
                  </label>
                  <input
                    :id="'telefone-anf-' + idx"
                    v-model="visitantesForm[idx].telefoneWhatsapp"
                    type="text"
                    placeholder="Telefone ou WhatsApp"
                  />
                </div>
              </div>
            </div>
            <div class="alinha-centro" style="margin-top: 0.5rem">
              <button type="button" class="acao-secundaria" @click="adicionarVisitanteAoFormulario">
                <i class="fa-solid fa-user-plus"></i> Adicionar outro visitante
              </button>
            </div>
          </template>
        </div>
      </div>
      <div class="margem container">
        <div class="bloco margem margem-topo solicitacao-form-secao-cartao">
          <h2 class="solicitacao-form-secao-cartao-titulo">
            <i class="fa-solid fa-handshake"></i> Tipo de Visitante
          </h2>
          <div class="grid-4">
            <div class="bloco margem col-3">
              <div>
                <label><input v-model="form.tipoCliente" type="checkbox" /> Cliente</label>
              </div>
              <div>
                <label><input v-model="form.tipoFornecedor" type="checkbox" /> Fornecedor</label>
              </div>
              <div>
                <label><input v-model="form.tipoPrestadorServico" type="checkbox" /> Prestador de serviço</label>
              </div>
              <div>
                <label><input v-model="form.tipoParceiros" type="checkbox" /> Parceiros</label>
              </div>
              <div>
                <label><input v-model="form.tipoOutros" type="checkbox" /> Outros</label>
                <input v-if="form.tipoOutros" id="tipoOutrosDescricaoAnf" v-model="form.tipoOutrosDescricao" type="text"
                  placeholder="Descreva o tipo de visitante" style="margin-top: 0.5rem; width: 100%; max-width: 28rem;" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="margem container">
        <div class="bloco margem margem-topo solicitacao-form-secao-cartao">
          <h2 class="solicitacao-form-secao-cartao-titulo">
            <i class="fa-solid fa-industry"></i> Necessidades logísticas
          </h2>
          <div class="grid-4">
            <div class="bloco margem col-3">
              <p class="fonte-menor fonte-fraca m-b">Marque o que for necessário para o dia da visita.</p>
              <div>
                <label for="nl-fab-anf"><input id="nl-fab-anf" v-model="form.visitaraFabrica" type="checkbox" /> Visitará à
                  fábrica</label>
              </div>
              <div>
                <label for="nl-lite-anf"><input id="nl-lite-anf" v-model="form.salaReuniaoLite" type="checkbox" /> Sala de
                  reunião Lite</label>
              </div>
              <div>
                <label for="nl-hard-anf"><input id="nl-hard-anf" v-model="form.salaReuniaoHard" type="checkbox" /> Sala de
                  reunião Hard</label>
              </div>
              <div>
                <label for="nl-cafe-anf"><input id="nl-cafe-anf" v-model="form.cafe" type="checkbox" /> Café</label>
              </div>
              <div>
                <label for="nl-agua-anf"><input id="nl-agua-anf" v-model="form.agua" type="checkbox" /> Água</label>
              </div>
              <div>
                <label for="nl-pao-anf"><input id="nl-pao-anf" v-model="form.paoQueijoBiscoito" type="checkbox" /> Pão de
                  queijo ou biscoito</label>
              </div>
              <div>
                <label for="nl-brinde-anf"><input id="nl-brinde-anf" v-model="form.brinde" type="checkbox" /> Brinde</label>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="emModal && !modoRecepcaoAgenda" class="margem container">
        <div class="bloco margem margem-topo solicitacao-form-secao-cartao">
          <h2 class="solicitacao-form-secao-cartao-titulo">
            <i class="fa-solid fa-note-sticky"></i> Observação
          </h2>
          <div class="grid-4">
            <div class="bloco margem col-3">
              <label for="observacao-visita-modal-anf">Observações adicionais <span class="fonte-menor fonte-fraca">(opcional)</span></label>
              <textarea
                id="observacao-visita-modal-anf"
                v-model="form.observacaoVisita"
                rows="3"
                placeholder="Informações complementares para a recepção..."
                class="solicitacao-textarea-obs"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="grid margem container solicitacao-form-acoes-modal">
        <div class="col-2 alinha-centro" style="margin-top: 1rem;">
          <button type="submit" :disabled="salvando">
            <i v-if="salvando" class="fas fa-spinner fa-spin"></i>
            <span v-if="salvando">Enviando...</span>
            <span v-else-if="emModal && modoRecepcaoAgenda">Enviar solicitação</span>
            <span v-else>Enviar para a recepção</span>
          </button>
          <router-link v-if="!emModal" to="/solicitacoes" class="acao-secundaria" style="cursor: pointer; margin-left: 0.5rem;">Voltar à
            lista</router-link>
          <button
            v-else
            type="button"
            class="acao-secundaria solicitacao-modal-btn-fechar"
            @click="fecharEmbedded"
          >
            Fechar
          </button>
        </div>
      </div>
    </form>
    <div v-if="!id && enviadoAnfitriaoSucesso && !emModal" class="margem container">
      <div class="bloco margem primaria-fraca txt-sucesso" style="padding: 1rem; border-radius: 6px;">
        <i class="fa-solid fa-circle-check"></i>
        <span>{{ textoMensagemSucessoAnfitriao }}</span>
      </div>
    </div>
    <!-- Modais auxiliares (teleportados ao body quando embutidos na agenda) -->
    <Teleport to="body" :disabled="!emModal">
      <div v-if="modalAnfitriaoAberto" class="modal-overlay modal-overlay--sol-embedded" role="dialog" aria-modal="true"
        aria-labelledby="modal-anfit-titulo">
      <div class="modal-backdrop" @click="modalAnfitriaoAberto = false"></div>
      <div class="modal-sheet">
        <h3 id="modal-anfit-titulo" class="modal-titulo">Buscar anfitrião(ã)</h3>
        <input v-model="anfitriaoBuscaTermo" type="search" class="modal-busca-input"
          placeholder="Filtrar por nome ou setor..." autocomplete="off" />
        <div v-if="anfitriaoCarregandoLista" class="modal-loading alinha-centro">
          <i class="fas fa-spinner fa-spin"></i>
        </div>
        <p v-else-if="anfitrioesFiltrados.length === 0" class="modal-vazio">Nenhum resultado.</p>
        <ul v-else class="modal-lista">
          <li v-for="item in anfitrioesFiltrados" :key="item.id" class="modal-item"
            @click="selecionarAnfitriaoCadastrado(item)">
            <i class="fa-regular fa-user modal-item-icone"></i>
            <div class="modal-item-textos">
              <span class="modal-item-nome">{{ nomeExibicaoAnfitriaoFn(item) }}</span>
              <span class="modal-item-meta">{{ item.setor_nome?.trim() ? `Setor: ${item.setor_nome}` : "Setor não informado no cadastro" }}</span>
            </div>
            <i class="fa-solid fa-chevron-right modal-item-seta"></i>
          </li>
        </ul>
        <button type="button" class="modal-fechar" @click="modalAnfitriaoAberto = false">Fechar</button>
      </div>
    </div>
    <!-- Modal: setor a visitar (estrutura organizacional) -->
    <div v-if="modalSetorAberto" class="modal-overlay modal-overlay--sol-embedded" role="dialog" aria-modal="true"
      aria-labelledby="modal-setor-titulo">
      <div class="modal-backdrop" @click="modalSetorAberto = false"></div>
      <div class="modal-sheet">
        <h3 id="modal-setor-titulo" class="modal-titulo">Setor a visitar</h3>
        <input
          v-model="setorBuscaTermo"
          type="search"
          class="modal-busca-input"
          placeholder="Filtrar por nome do setor…"
          autocomplete="off"
        />
        <ul class="modal-lista modal-lista-setor">
          <li v-for="s in setoresFiltrados" :key="s.id" class="modal-item"
            :class="{ ativo: form.areaSetorVisitado === s.nome }" @click="selecionarSetorVisitado(s.nome)">
            <span class="modal-item-nome" :style="estiloOptionSetor(s)">{{ rotuloSetorSelect(s) }}</span>
            <i v-if="form.areaSetorVisitado === s.nome" class="fa-solid fa-circle-check modal-check"></i>
          </li>
          <li v-if="areaSetorOrfao" class="modal-item ativo" @click="selecionarSetorVisitado(form.areaSetorVisitado)">
            <span class="modal-item-nome">{{ form.areaSetorVisitado }} (cadastro anterior)</span>
            <i class="fa-solid fa-circle-check modal-check"></i>
          </li>
        </ul>
        <button type="button" class="modal-fechar" @click="modalSetorAberto = false">Fechar</button>
      </div>
    </div>
    <!-- Modal: buscar visitante cadastrado -->
    <div v-if="modalVisitanteBuscaAberto" class="modal-overlay modal-overlay--sol-embedded" role="dialog" aria-modal="true"
      aria-labelledby="modal-vis-titulo">
      <div class="modal-backdrop" @click="fecharModalVisitanteBusca"></div>
      <div class="modal-sheet">
        <h3 id="modal-vis-titulo" class="modal-titulo">Buscar visitante cadastrado</h3>
        <input v-model="visitanteBuscaTermo" type="search" class="modal-busca-input"
          placeholder="Nome ou documento (CPF/RG)" autocomplete="off" @input="agendarBuscaVisitante" />
        <div v-if="visitanteBuscaCarregando" class="modal-loading alinha-centro">
          <i class="fas fa-spinner fa-spin"></i>
        </div>
        <p v-else-if="visitanteBuscaTermo.trim().length < 2" class="modal-vazio">
          Mínimo 2 caracteres (nome ou documento). Vários resultados: digite 4+ dígitos do documento para refinar — mesmo
          comportamento do app.
        </p>
        <p v-else-if="visitanteBuscaResultados.length === 0" class="modal-vazio">Nenhum visitante encontrado.</p>
        <ul v-else class="modal-lista">
          <li v-for="item in visitanteBuscaResultados" :key="'vis-' + item.id" class="modal-item"
            @click="selecionarVisitanteCadastrado(item)">
            <i class="fa-regular fa-user modal-item-icone"></i>
            <div class="modal-item-textos">
              <span class="modal-item-nome">{{ item.nomeCompleto }}</span>
              <span class="modal-item-meta">{{ metaLinhaVisitanteBusca(item) }}</span>
            </div>
            <i class="fa-solid fa-chevron-right modal-item-seta"></i>
          </li>
        </ul>
        <button type="button" class="modal-fechar" @click="fecharModalVisitanteBusca">Fechar</button>
      </div>
    </div>
    </Teleport>
  </section>
</template>
<script>
import { createToaster } from "@meforma/vue-toaster";
import { sso } from "roboflex-thalamus-sso-lib";
import SolicitacaoVisita from "@/models/SolicitacaoVisita";
import solicitacaoVisitaService from "@/services/solicitacao-visita-service";
import setorService from "@/services/setor-service";
import { rotuloSetorSelect, estiloOptionSetor } from "@/utils/setor-hierarquia";
import { listarSugestoesAnfitriao, obterPessoaPorUsuarioId, nomeExibicaoAnfitriao } from "@/services/anfitriao-service";
import {
  MOTIVOS_VISITA,
  parseMotivoVisitaFromStoredText,
  resolveMotivoVisitaParaApi,
} from "@/config/motivos-visita";
import visitanteService from "@/services/visitante-service";
import { STORAGE_PREFILL_VISITANTE } from "@/utils/acesso-prefill-visitante";
import { isDataVisitaEstritamentePassada, ehVisitaPorPeriodo } from "@/utils/visita-data";
import {
  aplicarDocumentoUnicoVisitante,
  linhaDocumentosVisitante,
  normalizarVisitanteDocumentos,
  valorDocumentoUnicoVisitante,
  visitanteLinhaVaziaDocumentos,
  visitanteParaPayloadApi,
} from "@/config/visitante-documentos";
import { ETAPAS_FLUXO_DIGITAL, TEXTO_BOTAO_FLUXO_DIGITAL_ETAPA, isentaFluxoDigitalRecepcao } from "@/config/fluxo-digital-solicitacao";

const toaster = createToaster({ position: "top-right" });

const ETAPAS_STATUS = [
  { valor: 1, label: "1. Solicitação" },
  { valor: 4, label: "2. Check-in" },
  { valor: 5, label: "3. Acompanhamento" },
  { valor: 6, label: "4. Check-out" },
];

export default {
  name: "SolicitacaoVisitaView",

  components: {},

  props: {
    emModal: { type: Boolean, default: false },
    /** Cadastro direto pela recepção no modal da agenda (formulário enxuto). */
    modoRecepcaoAgenda: { type: Boolean, default: false },
    /** Data inicial YYYY-MM-DD quando embutido na agenda (modal). */
    dataVisitaInicial: { type: String, default: "" },
  },

  emits: ["fechar"],

  data() {
    return {
      form: new SolicitacaoVisita({
        agendada: true,
        dataSolicitacao: null,
        visitantes: [{ nomeCompleto: "", documentoRgCnh: "", email: "", telefoneWhatsapp: "", visitanteId: null }],
      }),
      /** Lista editável de visitantes */
      visitantesForm: [],
      etapasStatus: ETAPAS_STATUS,
      salvando: false,
      nomeAnexo: "",
      mostrarStatus: false,
      /** chave da etapa do fluxo digital enquanto salva (ex.: convite, presenca, sala, logistica) */
      salvandoConvite: false,
      /** Setores da estrutura organizacional (combo “área/setor visitado”). */
      setoresLista: [],
      setoresCarregando: false,
      /** Fluxo anfitrião(ã) como no app mobile (nova solicitação) */
      anfitriaoUsuarioId: null,
      modalAnfitriaoAberto: false,
      anfitriaoLista: [],
      anfitriaoBuscaTermo: "",
      anfitriaoCarregandoLista: false,
      motivosVisita: MOTIVOS_VISITA,
      motivoId: "",
      modalSetorAberto: false,
      setorBuscaTermo: "",
      enviadoAnfitriaoSucesso: false,
      quantidadeEnviadaAnfitriao: 1,
      /** Busca visitante já cadastrado (recepção e anfitrião) */
      modalVisitanteBuscaAberto: false,
      visitanteBuscaTermo: "",
      visitanteBuscaResultados: [],
      visitanteBuscaCarregando: false,
      visitanteBuscaDebounceTimer: null,
      /** Índice em `visitantesForm` ao usar o modal «Buscar visitante cadastrado». */
      visitanteBuscaSlotIndex: 0,
      tipoAgendamentoVisita: "diaria",
    };
  },

  computed: {
    id() {
      return this.$route.params.id || null;
    },
    tituloPagina() {
      if (this.id) return "Solicitação de Agendamento de Visita";
      return "Cadastrar visita";
    },
    textoMensagemSucessoAnfitriao() {
      const plural = this.quantidadeEnviadaAnfitriao > 1;
      const parte = plural ? "Visitantes informados com sucesso." : "Visitante informado com sucesso.";
      return parte + " A recepcionista completará a solicitação de visita.";
    },
    textoBotaoEnviar() {
      if (this.informadaPeloAnfitriao && this.id) return "Salvar solicitação completa";
      return "Enviar solicitação";
    },
    informadaPeloAnfitriao() {
      const f = this.form;
      return f.origem === "anfitriao" || (f.nomeCompleto && !f.cpf && !f.rg && !f.empresaOrigem);
    },
    /**
     * Só leitura do fluxo apenas ao abrir a solicitação a partir de «Minhas solicitações» (?minhas=1).
     * A recepção abre a mesma rota sem essa query e vê os botões no cartão, mesmo que o SSO coincida com criador/anfitrião na API.
     */
    fluxoConviteDigitalSomenteLeituraAnfitriao() {
      if (!this.informadaPeloAnfitriao || !this.id) return false;
      return String(this.$route?.query?.minhas ?? "") === "1";
    },
    etapasFluxoConviteDigital() {
      return ETAPAS_FLUXO_DIGITAL;
    },
    textoBotaoFluxoDigitalEtapas() {
      return TEXTO_BOTAO_FLUXO_DIGITAL_ETAPA;
    },
    exigeFluxoDigitalRecepcao() {
      return !isentaFluxoDigitalRecepcao(this.form);
    },
    visitaDataPassadaSomenteLeitura() {
      if (!this.id || !this.form) return false;
      return isDataVisitaEstritamentePassada(this.form.dataVisita, this.form.dataVisitaFim);
    },
    formEdicaoDesabilitada() {
      if (!this.id || !this.form) return false;
      if (this.form.cancelada) return true;
      return isDataVisitaEstritamentePassada(this.form.dataVisita, this.form.dataVisitaFim);
    },
    /** Valor salvo como texto que não bate com nenhum setor atual (mantém opção no select). */
    areaSetorOrfao() {
      const v = this.form.areaSetorVisitado?.trim();
      if (!v) return false;
      return !this.setoresLista.some((s) => s.nome === v);
    },
    labelSetorVisita() {
      if (this.setoresCarregando) return "Carregando setores…";
      const t = (this.form.areaSetorVisitado || "").trim();
      if (!t) return "Selecione o setor";
      return t;
    },
    anfitrioesFiltrados() {
      const q = this.anfitriaoBuscaTermo.trim().toLowerCase();
      if (!q) return this.anfitriaoLista;
      return this.anfitriaoLista.filter(
        (x) =>
          nomeExibicaoAnfitriao(x).toLowerCase().includes(q) ||
          (x.setor_nome && x.setor_nome.toLowerCase().includes(q))
      );
    },
    setoresFiltrados() {
      const q = this.setorBuscaTermo.trim().toLowerCase();
      if (!q) return this.setoresLista;
      return this.setoresLista.filter(
        (s) =>
          rotuloSetorSelect(s).toLowerCase().includes(q) ||
          String(s.nome || "").toLowerCase().includes(q)
      );
    },
  },

  watch: {
    tipoAgendamentoVisita(val) {
      if (val === "diaria" && this.form) {
        this.form.dataVisitaFim = null;
      }
    },
    "$route.query.data": {
      handler() {
        if (!this.id && !this.emModal) this.$nextTick(() => this.aplicarDataDaRota());
      },
    },
    dataVisitaInicial: {
      handler() {
        if (this.id || !this.emModal) return;
        this.$nextTick(() => this.aplicarDataVisitaInicialProp());
      },
      immediate: true,
    },
  },

  created() {
    if (!this.visitantesForm.length) {
      this.visitantesForm = [this.emptyVisitanteSlot()];
    }
    this.carregarSetores();
    if (this.id) {
      this.carregar();
      this.mostrarStatus = true;
    } else {
      this.resetEstadoNovaVisitaAnfitriao();
    }
  },

  mounted() {
    if (!this.id) {
      this.$nextTick(() => {
        this.consumirPrefillDaAgenda();
        if (this.emModal) this.aplicarDataVisitaInicialProp();
        else this.aplicarDataDaRota();
      });
    }
  },

  beforeUnmount() {
    if (this.visitanteBuscaDebounceTimer) {
      clearTimeout(this.visitanteBuscaDebounceTimer);
      this.visitanteBuscaDebounceTimer = null;
    }
  },

  methods: {
    valorDocumentoUnicoVisitante,

    atualizarDocumentoVisitante(idx, valor) {
      aplicarDocumentoUnicoVisitante(this.visitantesForm[idx], valor);
    },

    sincronizarTipoAgendamentoDoFormulario() {
      this.tipoAgendamentoVisita = ehVisitaPorPeriodo(this.form?.dataVisita, this.form?.dataVisitaFim)
        ? "periodo"
        : "diaria";
    },

    aplicarTipoAgendamentoNoFormulario() {
      if (this.tipoAgendamentoVisita !== "periodo") {
        this.form.dataVisitaFim = null;
      }
    },

    rotuloSetorSelect,
    estiloOptionSetor,

    fecharEmbedded() {
      this.$emit("fechar");
    },

    aplicarDataVisitaInicialProp() {
      if (this.id || !this.emModal) return;
      const raw = this.dataVisitaInicial;
      if (!raw || typeof raw !== "string") return;
      const s = raw.trim().slice(0, 10);
      if (!/^\d{4}-\d{2}-\d{2}$/.test(s)) return;
      this.form.dataVisita = s;
      if (this.form.agendada === false) this.form.agendada = true;
    },

    consumirPrefillDaAgenda() {
      if (this.id) return;
      try {
        const raw = sessionStorage.getItem(STORAGE_PREFILL_VISITANTE);
        if (!raw) return;
        sessionStorage.removeItem(STORAGE_PREFILL_VISITANTE);
        const v = JSON.parse(raw);
        if (!v || typeof v !== "object") return;
        this.visitantesForm = [
          {
            _slotId: this.novoSlotIdVisitante(),
            nomeCompleto: String(v.nomeCompleto || "").trim(),
            cpf: String(v.cpf || v.CPF || "").trim(),
            rg: String(v.rg || v.documentoRgCnh || "").trim(),
            documentoRgCnh: String(v.rg || v.documentoRgCnh || "").trim(),
            email: String(v.email || "").trim(),
            telefoneWhatsapp: String(v.telefoneWhatsapp || "").trim(),
            visitanteId:
              v.visitanteId != null && Number(v.visitanteId) > 0
                ? Number(v.visitanteId)
                : v.visitante_id != null && Number(v.visitante_id) > 0
                  ? Number(v.visitante_id)
                  : null,
          },
        ];
      } catch (e) {
        console.error(e);
      }
    },

    aplicarDataDaRota() {
      if (this.id || this.emModal) return;
      const raw = this.$route.query.data ?? this.$route.query.dataVisita;
      if (!raw || typeof raw !== "string") return;
      const s = raw.trim().slice(0, 10);
      if (!/^\d{4}-\d{2}-\d{2}$/.test(s)) return;
      this.form.dataVisita = s;
      if (this.form.agendada === false) this.form.agendada = true;
    },

    resetEstadoNovaVisitaAnfitriao() {
      const u = sso.getUsuarioLogado?.() ?? {};
      const recepcaoModal = this.emModal && this.modoRecepcaoAgenda;
      this.form = new SolicitacaoVisita({
        agendada: true,
        dataSolicitacao: null,
        nomeAnfitriao: recepcaoModal ? "" : (u.nome ?? ""),
        anfitriaoUsuarioId: recepcaoModal ? null : (u.id ?? null),
        areaDepartamento: recepcaoModal ? "" : (u.departamento ?? ""),
        empresaOrigem: "",
        motivoVisita: "",
        observacaoVisita: "",
        areaSetorVisitado: "",
        dataVisita: null,
        horarioEntradaPrevisto: "",
        horarioSaidaPrevisto: "",
        visitantes: [{ nomeCompleto: "", documentoRgCnh: "", email: "", telefoneWhatsapp: "", visitanteId: null }],
      });
      this.visitantesForm = [this.emptyVisitanteSlot()];
      this.anfitriaoUsuarioId = recepcaoModal ? null : (u.id ?? null);
      this.motivoId = "";
      this.tipoAgendamentoVisita = "diaria";
      if (!recepcaoModal) {
        this.preencherAnfitriaoComUsuarioLogado();
      }
    },

    sincronizarMotivoDoTexto(motivoTexto) {
      this.motivoId = parseMotivoVisitaFromStoredText(motivoTexto);
    },

    motivoVisitaResolvido() {
      return resolveMotivoVisitaParaApi(this.motivoId).trim();
    },

    aplicarMotivoNoFormulario() {
      this.form.motivoVisita = this.motivoVisitaResolvido();
    },

    nomeExibicaoAnfitriaoFn(item) {
      return nomeExibicaoAnfitriao(item);
    },

    async abrirModalAnfitriao() {
      this.anfitriaoBuscaTermo = "";
      this.modalAnfitriaoAberto = true;
      this.anfitriaoCarregandoLista = true;
      try {
        this.anfitriaoLista = await listarSugestoesAnfitriao();
      } catch (e) {
        console.error(e);
        this.anfitriaoLista = [];
        toaster.show("Não foi possível carregar a lista de anfitriões.", { type: "error" });
      } finally {
        this.anfitriaoCarregandoLista = false;
      }
    },

    async aplicarAnfitriaoSelecionado(item, fecharModal = true) {
      if (fecharModal) this.modalAnfitriaoAberto = false;
      this.anfitriaoUsuarioId = item.id;
      this.form.nomeAnfitriao = nomeExibicaoAnfitriao(item);
      this.form.anfitriaoUsuarioId = item.id;
      let setor = item.setor_nome?.trim() || "";
      try {
        const det = await obterPessoaPorUsuarioId(item.id);
        if (det?.setor?.nome?.trim()) {
          setor = det.setor.nome.trim();
        }
      } catch (_) {
        // mantém setor já conhecido do item quando não conseguir buscar detalhes
      }
      this.form.areaDepartamento = setor;
    },

    async selecionarAnfitriaoCadastrado(item) {
      await this.aplicarAnfitriaoSelecionado(item, true);
    },

    async preencherAnfitriaoComUsuarioLogado() {
      if (this.id) return;
      const u = sso.getUsuarioLogado?.() ?? {};
      const id = Number(u.id ?? 0);
      if (!Number.isFinite(id) || id <= 0) return;
      const nomeBase = String(
        u.nome_completo ??
        u.nomeCompleto ??
        u.usuario_nome ??
        u.nome ??
        u.name ??
        ""
      ).trim();
      const item = {
        id,
        nome_completo: nomeBase || null,
        usuario_nome: nomeBase,
        setor_nome: String(u.departamento ?? "").trim(),
      };
      await this.aplicarAnfitriaoSelecionado(item, false);
    },

    limparAnfitriaoSelecionado() {
      this.anfitriaoUsuarioId = null;
      this.form.nomeAnfitriao = "";
      this.form.anfitriaoUsuarioId = null;
      this.form.areaDepartamento = "";
    },

    metaLinhaVisitanteBusca(item) {
      const docs = linhaDocumentosVisitante(item);
      const mail = String(item.email || "").trim();
      if (docs !== "Sem documento" && mail) return `${docs} · ${mail}`;
      if (docs !== "Sem documento") return docs;
      return mail || "Sem documento no cadastro";
    },

    novoSlotIdVisitante() {
      return `v-${Date.now()}-${Math.random().toString(36).slice(2, 9)}`;
    },

    emptyVisitanteSlot() {
      return {
        _slotId: this.novoSlotIdVisitante(),
        ...visitanteLinhaVaziaDocumentos(),
        nomeCompleto: "",
        email: "",
        telefoneWhatsapp: "",
        visitanteId: null,
      };
    },

    /** Cópia explícita de cada linha — evita referências compartilhadas no POST/PUT. */
    visitantesFormParaPayload() {
      return (this.visitantesForm || []).map((v) => {
        const docs = normalizarVisitanteDocumentos(v);
        const row = {
          nomeCompleto: String(v.nomeCompleto ?? "").trim(),
          cpf: docs.cpf,
          rg: docs.rg,
          documentoRgCnh: docs.rg,
          email: String(v.email ?? "").trim(),
          telefoneWhatsapp: String(v.telefoneWhatsapp ?? "").trim(),
        };
        const vid = v.visitanteId;
        if (vid != null && Number(vid) > 0) row.visitanteId = Number(vid);
        return row;
      });
    },

    adicionarVisitanteAoFormulario() {
      this.visitantesForm.push(this.emptyVisitanteSlot());
    },

    removerVisitanteDoFormulario(idx) {
      if (!Array.isArray(this.visitantesForm) || this.visitantesForm.length <= 1) return;
      const i = Number(idx);
      if (!Number.isFinite(i) || i < 0 || i >= this.visitantesForm.length) return;
      this.visitantesForm.splice(i, 1);
    },

    abrirModalVisitanteBusca(slotIndex = 0) {
      this.visitanteBuscaSlotIndex = Number(slotIndex) >= 0 ? Number(slotIndex) : 0;
      this.visitanteBuscaTermo = "";
      this.visitanteBuscaResultados = [];
      if (this.visitanteBuscaDebounceTimer) {
        clearTimeout(this.visitanteBuscaDebounceTimer);
        this.visitanteBuscaDebounceTimer = null;
      }
      this.modalVisitanteBuscaAberto = true;
    },

    fecharModalVisitanteBusca() {
      this.modalVisitanteBuscaAberto = false;
      if (this.visitanteBuscaDebounceTimer) {
        clearTimeout(this.visitanteBuscaDebounceTimer);
        this.visitanteBuscaDebounceTimer = null;
      }
    },

    agendarBuscaVisitante() {
      if (this.visitanteBuscaDebounceTimer) clearTimeout(this.visitanteBuscaDebounceTimer);
      this.visitanteBuscaDebounceTimer = setTimeout(() => {
        this.visitanteBuscaDebounceTimer = null;
        this.executarBuscaVisitante();
      }, 400);
    },

    async executarBuscaVisitante() {
      const q = this.visitanteBuscaTermo.trim();
      if (q.length < 2) {
        this.visitanteBuscaResultados = [];
        return;
      }
      this.visitanteBuscaCarregando = true;
      try {
        this.visitanteBuscaResultados = await visitanteService.buscarPorNome(q);
      } catch (e) {
        console.error(e);
        this.visitanteBuscaResultados = [];
        toaster.show("Erro ao buscar visitantes.", { type: "error" });
      } finally {
        this.visitanteBuscaCarregando = false;
      }
    },

    selecionarVisitanteCadastrado(item) {
      const idx = this.visitanteBuscaSlotIndex;
      if (!this.visitantesForm[idx]) return;
      const v = this.visitantesForm[idx];
      v.nomeCompleto = item.nomeCompleto || "";
      v.cpf = item.cpf || item.CPF || "";
      v.rg = item.rg || item.documentoRgCnh || "";
      v.documentoRgCnh = v.rg;
      v.email = item.email || "";
      v.telefoneWhatsapp = item.telefoneWhatsapp || "";
      const id = Number(item.id);
      v.visitanteId = Number.isFinite(id) && id > 0 ? id : null;
      this.modalVisitanteBuscaAberto = false;
      toaster.show("Dados carregados do cadastro de visitantes.", { type: "success" });
    },

    limparVinculoVisitanteCadastrado(slotIndex = 0) {
      const idx = Number(slotIndex);
      if (this.visitantesForm[idx]) this.visitantesForm[idx].visitanteId = null;
    },

    selecionarSetorVisitado(nome) {
      this.form.areaSetorVisitado = nome;
      this.setorBuscaTermo = "";
      this.modalSetorAberto = false;
    },

    async carregarSetores() {
      this.setoresCarregando = true;
      try {
        this.setoresLista = await setorService.obterListaEstruturaHierarquica();
      } catch (e) {
        console.error(e);
        this.setoresLista = [];
        toaster.show("Não foi possível carregar a lista de setores.", { type: "error" });
      } finally {
        this.setoresCarregando = false;
      }
    },

    /** Mesma lógica da Agenda: classes dos chips de status (bg-sucesso, bg-ok, bg-alerta, status-agendada) */
    statusPainel(s) {
      if (s >= 6) return 6;
      if (s >= 5) return 5;
      if (s >= 4) return 4;
      return 1;
    },

    classeBadgeStatus(s) {
      if (s >= 6) return "bg-sucesso";
      if (s >= 5) return "bg-ok";
      if (s >= 4) return "bg-alerta";
      return "status-agendada";
    },

    formatarDataHora(val) {
      if (!val) return "—";
      const d = new Date(val);
      if (isNaN(d.getTime())) return String(val);
      return d.toLocaleString("pt-BR", { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" });
    },

    dataEtapaFluxoDigital(etapa) {
      const f = this.form;
      const v = f[etapa.patch];
      if (v) return v;
      if (etapa.fallback) return f[etapa.fallback] ?? null;
      return null;
    },

    async marcarEtapaFluxoDigital(etapa) {
      if (!this.id || this.formEdicaoDesabilitada) return;
      this.salvandoConvite = etapa.salvando;
      try {
        const data = await solicitacaoVisitaService.atualizarFluxoConvite(this.id, {
          [etapa.patch]: new Date().toISOString(),
        });
        this.form = data;
        toaster.show(etapa.toast || "Etapa registrada.", { type: "success" });
      } catch (err) {
        console.error(err);
        const msg =
          err?.response?.data?.message ||
          err?.response?.data?.error ||
          (typeof err?.response?.data === "string" ? err.response.data : null) ||
          err?.message ||
          "Erro ao atualizar.";
        toaster.show(String(msg), { type: "error" });
      } finally {
        this.salvandoConvite = false;
      }
    },

    onAnexoChange(e) {
      if (this.formEdicaoDesabilitada) return;
      const file = e.target?.files?.[0];
      if (file) {
        this.form.anexoDocumento = file;
        this.nomeAnexo = file.name;
      }
    },

    async carregar() {
      try {
        const data = await solicitacaoVisitaService.obterPorId(this.id);
        if (data) {
          this.form = data;
          this.sincronizarMotivoDoTexto(data.motivoVisita);
          this.sincronizarTipoAgendamentoDoFormulario();
          this.anfitriaoUsuarioId = data.anfitriaoUsuarioId ?? null;
          const lista = Array.isArray(data.listaVisitantes) ? data.listaVisitantes : [];
          const mapeados = lista.map((v) => {
            const docs = normalizarVisitanteDocumentos(v);
            return {
            _slotId: this.novoSlotIdVisitante(),
            nomeCompleto: v.nomeCompleto ?? "",
            cpf: docs.cpf,
            rg: docs.rg,
            documentoRgCnh: docs.rg,
            email: v.email ?? "",
            telefoneWhatsapp: v.telefoneWhatsapp ?? "",
            visitanteId:
              v.visitanteId != null && Number(v.visitanteId) > 0
                ? Number(v.visitanteId)
                : v.visitante_id != null && Number(v.visitante_id) > 0
                  ? Number(v.visitante_id)
                  : null,
          };
          });
          this.visitantesForm = mapeados.length > 0 ? mapeados : [this.emptyVisitanteSlot()];
        }
        this.mostrarStatus = true;
      } catch (err) {
        console.error(err);
        toaster.show("Erro ao carregar solicitação.", { type: "error" });
      }
    },

    validar() {
      const invalidos = this.visitantesForm.filter((v) => !v.nomeCompleto?.trim());
      if (invalidos.length > 0) {
        toaster.show("Preencha o nome completo de cada visitante.", { type: "error" });
        return false;
      }
      this.aplicarMotivoNoFormulario();
      if (!this.form.motivoVisita?.trim()) {
        toaster.show("Informe o motivo da visita.", { type: "error" });
        return false;
      }
      if (!this.form.areaSetorVisitado?.trim()) {
        toaster.show("Informe a área ou setor a ser visitado.", { type: "error" });
        return false;
      }
      if (this.form.agendada && !this.form.dataVisita) {
        toaster.show("Informe a data da visita (obrigatório para visita agendada).", { type: "error" });
        return false;
      }
      if (this.tipoAgendamentoVisita === "periodo") {
        if (!this.form.dataVisita?.trim()) {
          toaster.show("Informe a data inicial do período.", { type: "error" });
          return false;
        }
        if (!this.form.dataVisitaFim?.trim()) {
          toaster.show("Informe a data final do período.", { type: "error" });
          return false;
        }
        if (String(this.form.dataVisitaFim).slice(0, 10) < String(this.form.dataVisita).slice(0, 10)) {
          toaster.show("A data final deve ser igual ou posterior à data inicial.", { type: "error" });
          return false;
        }
      }
      return true;
    },

    async enviar() {
      if (!this.id || !this.validar() || this.salvando) return;
      if (this.formEdicaoDesabilitada) {
        toaster.show("Não é possível alterar esta solicitação.", { type: "warning" });
        return;
      }
      this.salvando = true;
      try {
        this.aplicarMotivoNoFormulario();
        this.aplicarTipoAgendamentoNoFormulario();
        this.form.anfitriaoUsuarioId = this.anfitriaoUsuarioId ?? this.form.anfitriaoUsuarioId ?? null;
        const visitantesPayload = this.visitantesFormParaPayload();
        this.form.visitantes = visitantesPayload;
        const primeiro = visitantesPayload[0] || {};
        this.form.nomeCompleto = primeiro.nomeCompleto ?? "";
        this.form.cpf = primeiro.cpf ?? "";
        this.form.rg = primeiro.rg ?? "";
        this.form.documentoRgCnh = primeiro.rg ?? primeiro.documentoRgCnh ?? "";
        this.form.email = primeiro.email ?? "";
        this.form.telefoneWhatsapp = primeiro.telefoneWhatsapp ?? "";
        this.form.quantidadeVisitantes = visitantesPayload.length;
        await solicitacaoVisitaService.atualizar(this.id, this.form);
        toaster.show("Solicitação atualizada.", { type: "success" });
      } catch (err) {
        console.error(err);
        toaster.show(err?.response?.data?.message || "Erro ao salvar solicitação.", { type: "error" });
      } finally {
        this.salvando = false;
      }
    },

    async enviarAnfitriao() {
      const invalidos = this.visitantesForm.filter((v) => !v.nomeCompleto?.trim());
      if (invalidos.length > 0) {
        toaster.show("Preencha o nome completo de cada visitante.", { type: "error" });
        return;
      }
      if (!this.form.nomeAnfitriao?.trim()) {
        toaster.show("Informe o nome do anfitrião(ã).", { type: "error" });
        return;
      }
      if (!this.form.areaDepartamento?.trim()) {
        toaster.show("Informe a área/departamento.", { type: "error" });
        return;
      }
      if (this.salvando) return;
      this.salvando = true;
      this.enviadoAnfitriaoSucesso = false;
      try {
        this.aplicarMotivoNoFormulario();
        this.aplicarTipoAgendamentoNoFormulario();
        const visitantes = this.visitantesFormParaPayload().map((v) => {
          const row = {
            nome_completo: v.nomeCompleto,
            ...visitanteParaPayloadApi(v),
            email: v.email,
            telefone_whatsapp: v.telefoneWhatsapp,
          };
          if (v.visitanteId != null && Number(v.visitanteId) > 0) {
            row.visitante_id = Number(v.visitanteId);
          }
          return row;
        });
        const primeiro = visitantes[0] || {};
        const payload = {
          visitantes,
          nome_completo: primeiro.nome_completo || "",
          documento_rg_cnh: primeiro.rg || primeiro.documento_rg_cnh || "",
          cpf: primeiro.cpf || "",
          email: primeiro.email || "",
          telefone_whatsapp: primeiro.telefone_whatsapp || "",
          quantidade_visitantes: visitantes.length,
          motivo_visita: this.form.motivoVisita?.trim() || null,
          nome_anfitriao: this.form.nomeAnfitriao.trim(),
          anfitriao_usuario_id: this.form.anfitriaoUsuarioId ?? this.anfitriaoUsuarioId ?? null,
          area_departamento: this.form.areaDepartamento.trim(),
          empresa_origem: (this.form.empresaOrigem || "").trim() || null,
          area_setor_visitado: this.form.areaSetorVisitado?.trim() || null,
          data_visita: this.form.dataVisita || null,
          data_visita_fim:
            this.tipoAgendamentoVisita === "periodo" ? this.form.dataVisitaFim || null : null,
          horario_entrada_previsto: this.form.horarioEntradaPrevisto || null,
          horario_saida_previsto: this.form.horarioSaidaPrevisto || null,
          tipo_cliente: this.form.tipoCliente,
          tipo_fornecedor: this.form.tipoFornecedor,
          tipo_prestador_servico: this.form.tipoPrestadorServico,
          tipo_parceiros: this.form.tipoParceiros,
          tipo_outros: this.form.tipoOutros,
          tipo_outros_descricao: this.form.tipoOutrosDescricao || null,
          observacao_visita: (this.form.observacaoVisita || "").trim() || null,
          visitara_fabrica: this.form.visitaraFabrica,
          sala_reuniao_lite: this.form.salaReuniaoLite,
          sala_reuniao_hard: this.form.salaReuniaoHard,
          cafe: this.form.cafe,
          agua: this.form.agua,
          pao_queijo_biscoito: this.form.paoQueijoBiscoito,
          brinde: this.form.brinde,
          origem: "anfitriao",
        };
        await solicitacaoVisitaService.criarPeloAnfitriao(payload);
        this.quantidadeEnviadaAnfitriao = visitantes.length;
        const msg = this.quantidadeEnviadaAnfitriao > 1 ? "Visitantes informados." : "Visitante informado.";
        toaster.show(msg + " A recepção completará a solicitação.", { type: "success" });
        this.enviadoAnfitriaoSucesso = true;
        this.resetEstadoNovaVisitaAnfitriao();
        if (this.emModal) this.$emit("fechar");
      } catch (err) {
        console.error(err);
        toaster.show(err?.response?.data?.message || "Erro ao enviar. Tente novamente.", { type: "error" });
      } finally {
        this.salvando = false;
      }
    },

    async enviarRecepcaoAgenda() {
      if (!this.validar() || this.salvando) return;
      this.salvando = true;
      try {
        this.aplicarMotivoNoFormulario();
        this.aplicarTipoAgendamentoNoFormulario();
        const visitantesPayload = this.visitantesFormParaPayload();
        this.form.visitantes = visitantesPayload;
        const primeiro = visitantesPayload[0] || {};
        this.form.nomeCompleto = primeiro.nomeCompleto ?? "";
        this.form.cpf = primeiro.cpf ?? "";
        this.form.rg = primeiro.rg ?? "";
        this.form.documentoRgCnh = primeiro.rg ?? primeiro.documentoRgCnh ?? "";
        this.form.email = primeiro.email ?? "";
        this.form.telefoneWhatsapp = primeiro.telefoneWhatsapp ?? "";
        this.form.quantidadeVisitantes = visitantesPayload.length;
        this.form.statusAgendamento = 1;
        this.form.origem = null;
        await solicitacaoVisitaService.criar(this.form);
        toaster.show("Visita registrada.", { type: "success" });
        this.resetEstadoNovaVisitaAnfitriao();
        if (this.emModal) this.aplicarDataVisitaInicialProp();
        this.$emit("fechar");
      } catch (err) {
        console.error(err);
        toaster.show(err?.response?.data?.message || "Erro ao salvar solicitação.", { type: "error" });
      } finally {
        this.salvando = false;
      }
    },

  },
};
</script>
<style scoped>
.tipo-agendamento-opcoes {
  display: flex;
  flex-wrap: wrap;
  gap: 0.75rem 1.25rem;
  margin-top: 0.35rem;
}

.tipo-agendamento-opcoes label {
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  cursor: pointer;
}

.solicitacao-linha-tipo-agendamento {
  margin-top: 0.15rem;
  margin-bottom: 0.25rem;
}

.solicitacao-grid-datas-horarios {
  margin-top: 0.15rem;
}

.grid-datas-horarios-inner {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 0.75rem 1rem;
  align-items: end;
}

.grid-datas-horarios-inner > div {
  min-width: 0;
}

.grid-datas-horarios-inner label,
.solicitacao-linha-tipo-agendamento .label-picker {
  display: block;
  margin-bottom: 0.35rem;
}

.grid-datas-horarios-inner input[type="date"],
.grid-datas-horarios-inner input[type="time"] {
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
}

.solicitacao-linha-observacao {
  margin-top: 0.35rem;
}

.solicitacao-linha-observacao .solicitacao-textarea-obs {
  width: 100%;
  box-sizing: border-box;
}

@media screen and (min-width: 640px) {
  .grid-datas-horarios-inner {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }
}

@media screen and (max-width: 639px) {
  .grid-datas-horarios-inner {
    grid-template-columns: 1fr;
  }
}

.hint-multi-visitantes {
  margin: 0 0 0.75rem;
  line-height: 1.45;
}

.visitante-slot-card {
  padding-top: 0.5rem;
  border-top: 1px solid var(--cor-separador, #ddd);
}

.visitante-slot-card:first-of-type {
  border-top: none;
  padding-top: 0;
}

/* Alinha os inputs dos campos do visitante na mesma linha de base,
   mesmo quando os labels têm alturas diferentes (ex.: CPF/RG com
   observação que quebra em várias linhas). */
.visitante-slot-card .grid-4 > div {
  display: flex;
  flex-direction: column;
}

.visitante-slot-card .grid-4 > div > label {
  margin-bottom: 0.25rem;
}

.visitante-slot-card .grid-4 > div > input {
  margin-top: auto;
}

.solicitacao-textarea-obs {
  width: 100%;
  max-width: 36rem;
  min-height: 4.5rem;
  resize: vertical;
  margin-top: 0.35rem;
  padding: 0.5rem 0.65rem;
  line-height: 1.45;
  border-radius: 6px;
  border: 1px solid var(--cor-separador, #ccc);
  background: var(--cor-fundo-input, #fff);
  color: inherit;
  box-sizing: border-box;
}

.visitante-slot-cabecalho {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  flex-wrap: wrap;
  margin-bottom: 0.5rem;
}

.visitante-slot-titulo {
  margin: 0;
  font-size: 1.05rem;
  font-weight: 600;
}

.btn-remover-slot {
  font-size: 0.9rem;
  padding: 0.35rem 0.65rem;
}

.cadastro-anfitriao-dica {
  margin: 0 0 0.35rem 0;
  line-height: 1.45;
}

.icone-remove {
  cursor: pointer;
  color: var(--cor-erro);
  border: none;
  background: transparent;
  padding: 0.25rem 0.5rem;
  font-size: 1rem;
}

.icone-remove:hover {
  opacity: 0.8;
}

input[readonly] {
  background: var(--cor-cinza);
  cursor: not-allowed;
}

textarea {
  width: 100%;
  resize: vertical;
  min-height: 60px;
}

/* .chip global (thalamus) usa margin negativa em tabelas; no fluxo digital mantemos alinhamento limpo */
.fluxo-convite-etapas .chip {
  margin: 0;
  vertical-align: middle;
}

.fluxo-digital-card {
  box-sizing: border-box;
  padding: calc(var(--margem) * 0.85) var(--margem) var(--margem);
  border: 1px solid var(--cor-separador);
  box-shadow: 0 1px 24px var(--cor-cinza), 0 0 0 1px var(--cor-primaria-fraca) inset;
}

.fluxo-digital-cabecalho {
  display: flex;
  align-items: flex-start;
  gap: 1rem;
  padding-bottom: calc(var(--margem) * 0.75);
  margin-bottom: calc(var(--margem) * 0.75);
  border-bottom: 1px solid var(--cor-separador);
}

.fluxo-digital-cabecalho-icone {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 3rem;
  height: 3rem;
  border-radius: 12px;
  background: var(--cor-primaria-fraca);
  color: var(--cor-primaria-forte);
  font-size: 1.35rem;
}

.fluxo-digital-cabecalho-textos {
  flex: 1;
  min-width: 0;
}

.fluxo-digital-titulo {
  margin: 0 0 0.35rem 0;
  font-size: 1.25rem;
  line-height: 1.35;
  font-weight: 700;
  color: var(--cor-fonte-forte);
}

.fluxo-digital-subtitulo {
  margin: 0;
  font-size: 0.9rem;
  line-height: 1.5;
  color: var(--cor-fonte-fraca);
}

.fluxo-digital-etapas {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 0.85rem;
}

.fluxo-digital-etapa {
  position: relative;
  margin: 0;
}

.fluxo-digital-etapa-linha {
  display: flex;
  align-items: flex-start;
  gap: 1rem;
}

.fluxo-digital-etapa-num {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 2.25rem;
  height: 2.25rem;
  border-radius: 50%;
  font-size: 0.8rem;
  font-weight: 700;
  line-height: 1;
  border: 2px solid var(--cor-separador);
  background: var(--cor-bg);
  color: var(--cor-fonte-fraca);
}

.fluxo-digital-etapa-num--pendente {
  border-color: var(--cor-separador);
  background: var(--cor-cinza2);
  color: var(--cor-fonte);
}

.fluxo-digital-etapa-num--ok {
  border-color: transparent;
  background: var(--cor-sucesso);
  color: var(--cor-bg);
}

.fluxo-digital-etapa-corpo {
  flex: 1;
  min-width: 0;
  padding: 0.85rem 1rem 1rem;
  border-radius: 10px;
  border: 1px solid var(--cor-separador);
  background: var(--cor-bg);
  box-shadow: 0 1px 0 var(--cor-cinza2);
}

.fluxo-digital-etapa--feita .fluxo-digital-etapa-corpo {
  border-color: hsl(130 40% 78% / 0.9);
  background: linear-gradient(135deg, hsl(130 35% 97%) 0%, var(--cor-bg) 55%);
}

.fluxo-digital-etapa-titulo {
  margin: 0 0 0.35rem 0;
  font-size: 0.98rem;
  font-weight: 700;
  line-height: 1.35;
  color: var(--cor-fonte-forte);
}

.fluxo-digital-etapa-desc {
  margin: 0;
  font-size: 0.82rem;
  line-height: 1.5;
  color: var(--cor-fonte-fraca);
}

.fluxo-digital-etapa-rodape {
  margin-top: 0.85rem;
  padding-top: 0.75rem;
  border-top: 1px solid var(--cor-separador);
}

.fluxo-digital-status-linha {
  margin-top: 0;
}

.fluxo-digital-feito-msg {
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  font-size: 0.82rem;
  font-weight: 600;
  color: var(--cor-sucesso);
}

.fluxo-digital-feito-msg .fa-circle-check {
  font-size: 1rem;
  opacity: 0.95;
}

.fluxo-digital-btn-acao {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  width: auto;
  max-width: 100%;
  padding: 0.55rem 1.15rem;
  border-radius: 10px;
  font-size: 0.82rem;
  font-weight: 700;
  border: 1px solid transparent;
  background: linear-gradient(var(--cor-primaria), var(--cor-primaria-forte) 200%);
  color: var(--cor-bg);
  box-shadow: 0 1px 2px hsl(var(--h) var(--s) 30% / 0.2);
  transition: transform 0.12s ease, box-shadow 0.12s ease, opacity 0.12s ease;
}

.fluxo-digital-btn-acao:hover:not(:disabled) {
  transform: translateY(-1px);
  box-shadow: 0 3px 10px hsl(var(--h) var(--s) 40% / 0.25);
}

.fluxo-digital-btn-acao:active:not(:disabled) {
  transform: translateY(0);
}

.fluxo-digital-btn-acao:disabled {
  cursor: not-allowed;
  transform: none;
  box-shadow: none;
}

.fluxo-digital-conclusao {
  display: flex;
  align-items: flex-start;
  gap: 0.75rem;
  margin-top: calc(var(--margem) * 0.85);
  padding: 1rem 1.1rem;
  border-radius: 10px;
  border: 1px solid hsl(130 40% 72% / 0.65);
  background: linear-gradient(120deg, hsl(130 38% 94%) 0%, var(--cor-primaria-fraca) 120%);
  color: var(--cor-fonte-forte);
}

.fluxo-digital-conclusao-icone {
  flex-shrink: 0;
  margin-top: 0.1rem;
  font-size: 1.35rem;
  color: var(--cor-sucesso);
}

.fluxo-digital-conclusao-texto {
  margin: 0;
  font-size: 0.88rem;
  line-height: 1.5;
  font-weight: 600;
}

.dark .fluxo-digital-card {
  border-color: var(--cor-separador);
  box-shadow: 0 1px 16px rgba(0, 0, 0, 0.35), 0 0 0 1px var(--cor-primaria-media) inset;
}

.dark .fluxo-digital-etapa-corpo {
  background: var(--cor-bg);
  border-color: var(--cor-separador);
}

.dark .fluxo-digital-etapa--feita .fluxo-digital-etapa-corpo {
  border-color: hsl(130 25% 38% / 0.55);
  background: linear-gradient(135deg, hsl(130 18% 16%) 0%, var(--cor-bg) 70%);
}

.dark .fluxo-digital-conclusao {
  border-color: hsl(130 22% 32% / 0.85);
  background: linear-gradient(120deg, hsl(130 16% 18%) 0%, hsl(var(--h) 20% 14%) 100%);
}

.linha-fluxo-convite-status {
  display: inline-flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 0.5rem;
  margin-top: 0.15rem;
}

.chip-status-etapa {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
}

.chip-status-etapa .chip-label {
  font-size: 12px;
}

/* Secções em cartão (status, visita, visitante, logística…): mesma casca que .fluxo-digital-card */
.solicitacao-form-secao-cartao-titulo {
  margin: 0 0 calc(var(--margem) * 0.65) 0;
  font-size: 1.12rem;
  font-weight: 700;
  color: var(--cor-fonte-forte);
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.solicitacao-form-secao-cartao-titulo i {
  width: 2.25rem;
  height: 2.25rem;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
  background: var(--cor-primaria-fraca);
  color: var(--cor-primaria-forte);
  font-size: 1rem;
}

.solicitacao-visita-form .bloco.margem.margem-topo.solicitacao-form-secao-cartao {
  padding: calc(var(--margem) * 0.85) var(--margem) var(--margem);
  border: 1px solid var(--cor-separador);
  border-radius: 10px;
  box-shadow: 0 1px 24px var(--cor-cinza), 0 0 0 1px var(--cor-primaria-fraca) inset;
  box-sizing: border-box;
}

.dark .solicitacao-visita-form .bloco.margem.margem-topo.solicitacao-form-secao-cartao {
  border-color: var(--cor-separador);
  box-shadow: 0 1px 16px rgba(0, 0, 0, 0.35), 0 0 0 1px var(--cor-primaria-media) inset;
}

.solicitacao-form-status-chips {
  flex-wrap: wrap;
  align-items: center;
  gap: 0.5rem;
}

/* Igual à Agenda: chip pendente */
.status-agendada {
  background: var(--cor-cinza2);
  color: var(--cor-fonte);
}

/* Fluxo convite (visão anfitrião): pendente vs confirmado */
.chip-fluxo-pendente {
  background: hsl(38 95% 88%);
  color: hsl(28 55% 28%);
  border: 1px solid hsl(32 70% 55% / 0.45);
  font-weight: 600;
}

.req {
  color: var(--cor-erro);
}

.campo-linha-cheia {
  grid-column: 1 / -1;
}

.btn-buscar-cadastro {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.55rem 1rem;
  margin-bottom: 0.75rem;
  border: 1px solid var(--cor-primaria);
  border-radius: 8px;
  background: var(--cor-bg);
  color: var(--cor-primaria-forte);
  font-weight: 600;
  cursor: pointer;
  font-size: 0.95rem;
}

.btn-buscar-cadastro:hover {
  background: var(--cor-primaria-fraca);
}

.btn-buscar-visitante {
  margin-top: 0.45rem;
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  padding: 0.35rem 0.6rem;
  border: 1px solid var(--cor-primaria);
  border-radius: 6px;
  background: var(--cor-primaria-fraca);
  color: var(--cor-primaria-forte);
  cursor: pointer;
  font-size: 0.8rem;
  font-weight: 600;
}

.read-only-box {
  padding: 0.55rem 0.75rem;
  background: var(--cor-cinza);
  border: 1px solid var(--cor-separador);
  border-radius: 6px;
  font-size: 0.95rem;
}

.label-readonly {
  display: block;
  font-size: 0.9rem;
  font-weight: 500;
  margin-bottom: 0.35rem;
}

.anfit-leitura-bloco {
  margin-top: 0.25rem;
}

.anfit-leitura-linha {
  display: flex;
  align-items: flex-start;
  gap: 0.75rem;
  flex-wrap: wrap;
}

.anfit-leitura-campo {
  flex: 1;
  min-width: 12rem;
}

.margem-topo-peq {
  margin-top: 0.75rem;
}

.btn-alterar-anfitriao {
  margin-top: 1.6rem;
  padding: 0.35rem 0.65rem;
  border: none;
  background: transparent;
  color: var(--cor-primaria-forte);
  font-weight: 600;
  cursor: pointer;
  text-decoration: underline;
  font-size: 0.9rem;
}

.hint-anfitriao {
  margin: 0.35rem 0 0 0;
  line-height: 1.4;
}

.label-picker {
  display: block;
  margin-bottom: 0.35rem;
  font-weight: 500;
}

.btn-picker-setor {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  max-width: 100%;
  padding: 0.55rem 0.75rem;
  border: 1px solid var(--cor-separador);
  border-radius: 6px;
  background: var(--cor-bg);
  font-size: 0.95rem;
  text-align: left;
  cursor: pointer;
  color: var(--cor-fonte);
}

.btn-picker-setor:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

.btn-picker-texto.placeholder {
  color: var(--cor-fonte-fraca);
}

/* Modais (mesmo padrão do app: lista + busca) */
.modal-overlay {
  position: fixed;
  inset: 0;
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1rem;
}

.modal-overlay--sol-embedded {
  z-index: 1100;
}

.modal-backdrop {
  position: absolute;
  inset: 0;
  background: rgba(0, 0, 0, 0.45);
}

.modal-sheet {
  position: relative;
  z-index: 1;
  width: 100%;
  max-width: 28rem;
  max-height: min(85vh, 520px);
  display: flex;
  flex-direction: column;
  background: var(--cor-bg);
  border-radius: 12px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);
  padding: 1rem 1rem 0.75rem;
}

.modal-titulo {
  margin: 0 0 0.75rem 0;
  font-size: 1.05rem;
  font-weight: 700;
}

.modal-busca-input {
  width: 100%;
  padding: 0.5rem 0.65rem;
  border: 1px solid var(--cor-separador);
  border-radius: 6px;
  margin-bottom: 0.5rem;
  font-size: 0.95rem;
}

.buscar-visitante-linha {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-bottom: 0.5rem;
}

.buscar-visitante-input {
  margin-bottom: 0;
}

.buscar-visitante-acao {
  width: 2.5rem;
  height: 2.5rem;
  border: none;
  border-radius: 6px;
  background: var(--cor-primaria);
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.buscar-visitante-erro {
  margin: 0 0 0.5rem 0;
  color: var(--cor-erro);
  font-size: 0.85rem;
}

.modal-loading {
  padding: 1.25rem;
}

.modal-vazio {
  margin: 0.5rem 0 0.75rem;
  padding: 0.5rem;
  color: var(--cor-fonte-fraca);
  font-size: 0.9rem;
  text-align: center;
}

.modal-lista {
  list-style: none;
  margin: 0;
  padding: 0;
  overflow-y: auto;
  flex: 1;
  min-height: 0;
}

.modal-item {
  display: flex;
  align-items: center;
  gap: 0.65rem;
  padding: 0.65rem 0.5rem;
  border-bottom: 1px solid var(--cor-separador);
  cursor: pointer;
  border-radius: 6px;
}

.modal-item:hover {
  background: var(--cor-primaria-fraca);
}

.modal-item.ativo {
  background: var(--cor-primaria-fraca);
}

.modal-item-icone {
  flex-shrink: 0;
  color: var(--cor-primaria-forte);
}

.modal-item-textos {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 0.15rem;
}

.modal-item-nome {
  font-weight: 600;
  font-size: 0.95rem;
}

.modal-item-meta {
  font-size: 0.8rem;
  color: var(--cor-fonte-fraca);
}

.modal-item-seta {
  flex-shrink: 0;
  color: var(--cor-primaria-forte);
  font-size: 0.85rem;
}

.visitante-thumb {
  width: 2rem;
  height: 2rem;
  border-radius: 50%;
  object-fit: cover;
  flex-shrink: 0;
}

.visitante-thumb-placeholder {
  width: 2rem;
  height: 2rem;
  border-radius: 50%;
  border: 1px solid var(--cor-separador);
  background: var(--cor-cinza2);
  color: var(--cor-fonte-fraca);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.modal-check {
  flex-shrink: 0;
  color: var(--cor-primaria-forte);
}

.modal-lista-setor .modal-item {
  justify-content: space-between;
}

.modal-fechar {
  margin-top: 0.5rem;
  padding: 0.5rem;
  width: 100%;
  border: none;
  background: transparent;
  color: var(--cor-primaria-forte);
  font-weight: 600;
  cursor: pointer;
}

.modal-fechar:hover {
  text-decoration: underline;
}

/* Dentro do modal “Cadastrar visita” na agenda */
.solicitacao-visita--modal {
  display: block;
}

.solicitacao-visita--modal .margem.container,
.solicitacao-visita--modal .grid.margem.container {
  max-width: 100%;
  padding: 0;
  margin-left: 0;
  margin-right: 0;
  box-sizing: border-box;
}

.solicitacao-visita--modal .bloco.margem.margem-topo.solicitacao-form-secao-cartao {
  margin-top: 0.65rem;
  padding: 0.85rem 0.95rem;
  box-shadow: 0 1px 8px var(--cor-cinza);
}

.solicitacao-visita--modal form > .margem.container:first-of-type .solicitacao-form-secao-cartao,
.solicitacao-visita-form--recepcao-modal > .margem.container:first-of-type .solicitacao-form-secao-cartao {
  margin-top: 0;
}

.solicitacao-visita--modal .solicitacao-form-acoes-modal {
  position: sticky;
  bottom: 0;
  z-index: 2;
  margin-top: 0.75rem;
  padding: 0.85rem 0 0.35rem;
  background: linear-gradient(180deg, transparent 0%, var(--cor-bg) 24%);
  border-top: 1px solid var(--cor-separador);
}

.solicitacao-visita--modal .solicitacao-form-acoes-modal .col-2.alinha-centro {
  margin-top: 0 !important;
  padding-top: 0;
  border-top: none;
}

.solicitacao-visita--modal .grid-datas-horarios-inner {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}

@media screen and (min-width: 720px) {
  .solicitacao-visita--modal .grid-datas-horarios-inner {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }
}

.solicitacao-visita--modal form h2 {
  font-size: 1.05rem;
  margin-top: 1.2rem;
  margin-bottom: 0.5rem;
  padding-bottom: 0.4rem;
  border-bottom: 1px solid var(--cor-separador);
}

.solicitacao-visita--modal form > .margem.container:first-of-type .solicitacao-form-secao-cartao-titulo {
  margin-top: 0;
}

.solicitacao-modal-btn-fechar {
  margin-left: 0.5rem;
}

.solicitacao-visita--modal .solicitacao-modal-btn-fechar {
  padding: 0.55rem 1rem;
  border-radius: 8px;
  border: 1px solid var(--cor-separador);
  background: var(--cor-bg);
  font-weight: 600;
}

.solicitacao-visita--modal .solicitacao-modal-btn-fechar:hover {
  background: var(--cor-cinza2, rgba(0, 0, 0, 0.05));
}

.solicitacao-visita--modal .grid.margem.container .col-2.alinha-centro {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  gap: 0.65rem 0.85rem;
  margin-top: 1.25rem !important;
  padding-top: 1.15rem;
  border-top: 1px solid var(--cor-separador);
}

.solicitacao-edicao-fieldset {
  border: none;
  margin: 0;
  padding: 0;
  min-width: 0;
}

/* Alertas / avisos no topo do formulário */
.sol-alerta {
  display: flex;
  align-items: flex-start;
  gap: 0.75rem;
  padding: 0.9rem 1.05rem;
  border-radius: 10px;
  line-height: 1.45;
  border: 1px solid var(--cor-separador);
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
}

.sol-alerta-icone {
  flex-shrink: 0;
  font-size: 1.2rem;
  margin-top: 0.05rem;
}

.sol-alerta-texto {
  flex: 1;
  min-width: 0;
  font-size: 0.9rem;
}

.sol-alerta--erro {
  border-color: hsl(0 45% 78%);
  background: linear-gradient(135deg, hsl(0 65% 97%) 0%, var(--cor-bg) 72%);
  color: var(--cor-fonte-forte);
}

.sol-alerta--erro .sol-alerta-icone {
  color: var(--cor-erro);
}

.sol-alerta--info {
  border-color: hsl(var(--h) 38% 82%);
  background: linear-gradient(135deg, var(--cor-primaria-fraca) 0%, var(--cor-bg) 88%);
}

.sol-alerta--info .sol-alerta-icone {
  color: var(--cor-primaria-forte);
}

.sol-alerta--passada {
  border-color: var(--cor-separador);
  background: linear-gradient(120deg, var(--cor-primaria-fraca) 0%, var(--cor-bg) 65%);
}

.dark .sol-alerta--erro {
  background: linear-gradient(135deg, hsl(0 30% 16%) 0%, var(--cor-bg) 80%);
  border-color: hsl(0 25% 36%);
}

.dark .sol-alerta--info {
  background: linear-gradient(135deg, hsl(var(--h) 22% 16%) 0%, var(--cor-bg) 85%);
}

.dark .sol-alerta--passada {
  background: linear-gradient(120deg, hsl(var(--h) 18% 16%) 0%, var(--cor-bg) 70%);
}

/* Mesmo enquadramento do cartão do fluxo (padding global .margem + .sol-alerta empilhavam de outro modo) */
.solicitacao-visita-form .bloco.margem.margem-topo.sol-alerta {
  box-sizing: border-box;
  padding: calc(var(--margem) * 0.85) var(--margem) var(--margem);
  box-shadow: 0 1px 24px var(--cor-cinza), 0 0 0 1px var(--cor-primaria-fraca) inset;
}

.dark .solicitacao-visita-form .bloco.margem.margem-topo.sol-alerta {
  box-shadow: 0 1px 16px rgba(0, 0, 0, 0.35), 0 0 0 1px var(--cor-primaria-media) inset;
}

/* Formulário principal (página, não modal): fieldset e secções */
section:not(.solicitacao-visita--modal) .solicitacao-visita-form fieldset.solicitacao-edicao-fieldset {
  margin-top: 0.35rem;
  padding: 1.15rem 0 1.35rem;
  border-radius: 12px;
  border: 1px solid var(--cor-separador);
  background: linear-gradient(180deg, hsl(var(--h) var(--s) 97% / 0.45) 0%, var(--cor-bg) 12rem);
  box-shadow: 0 1px 14px var(--cor-cinza);
}

.dark section:not(.solicitacao-visita--modal) .solicitacao-visita-form fieldset.solicitacao-edicao-fieldset {
  background: linear-gradient(180deg, hsl(var(--h) 22% 14%) 0%, var(--cor-bg) 12rem);
}

.solicitacao-visita-form fieldset > .margem.container:first-of-type .solicitacao-form-secao-cartao-titulo {
  margin-top: 0.35rem;
}

/* Evita moldura dupla: o cartão externo já traz borda e padding */
.solicitacao-visita-form .solicitacao-form-secao-cartao .grid-4 > .bloco.margem.col-3 {
  border: none;
  box-shadow: none;
  padding: 0;
}

.solicitacao-visita-form fieldset .bloco .bloco.margem {
  margin-top: 0.75rem;
  padding: 0.85rem 0.95rem;
  border-radius: 8px;
  border: 1px dashed var(--cor-separador);
  background: var(--cor-cinza);
}

.solicitacao-visita-form .solicitacao-form-secao-cartao .bloco.margem.col-3 label {
  display: flex;
  align-items: center;
  gap: 0.45rem;
  padding: 0.3rem 0.2rem;
  margin-bottom: 0.15rem;
  border-radius: 6px;
  cursor: pointer;
}

.solicitacao-visita-form .solicitacao-form-secao-cartao .bloco.margem.col-3 label:hover {
  background: var(--cor-cinza2);
}

.solicitacao-visita-form .btn-picker-setor {
  border-radius: 8px;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
}

.solicitacao-visita-form .btn-picker-setor:hover:not(:disabled) {
  border-color: var(--cor-primaria);
  box-shadow: 0 0 0 1px var(--cor-primaria-media);
}

.solicitacao-form-acoes {
  padding-bottom: 1.5rem;
}

.solicitacao-form-acoes-inner {
  margin-top: 1rem !important;
  padding: 1.2rem 1rem 0.25rem;
  border-top: 1px solid var(--cor-separador);
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  gap: 0.75rem 1rem;
}

section:not(.solicitacao-visita--modal) .solicitacao-form-acoes-inner {
  background: linear-gradient(180deg, transparent 0%, var(--cor-cinza) 10rem);
  border-radius: 0 0 12px 12px;
  margin-left: calc(var(--margem) * -0.25);
  margin-right: calc(var(--margem) * -0.25);
  padding-left: calc(var(--margem) * 1.25);
  padding-right: calc(var(--margem) * 1.25);
}

@media screen and (max-width: 970px) {
  section:not(.solicitacao-visita--modal) .solicitacao-form-acoes-inner {
    margin-left: 0;
    margin-right: 0;
    padding-left: 1rem;
    padding-right: 1rem;
  }
}
</style>
